const API_URL = `${process.env.API_V4_HOST}/_exclusive/agent-yearbooks`;
export const getAgentYearbookSummaries = $axios => $axios.$get(`${API_URL}/summaries`, {
  validateStatus: status => status < 500,
});
export const generateAgentYearbookImage = $axios => $axios.$post(`${API_URL}/images`);
export const generateAgentYearbookVoucher = $axios => $axios.$post(`${API_URL}/vouchers`, {
  validateStatus: status => status < 500,
});

export const yearbookGeneralData = {
  name: 'Pak Warmo',
  gmv: 35000000,
  flow: {
    vp: true,
    gt: false,
  },
  achievement: {
    gmv: 1342700,
    length: 300,
    recency: 14,
    title: 'grocery',
    trx_count: 4215,
  },
  vp: {
    customer_count: 102498,
    customer_name: 'Pelanggan',
  },
  total_voucher: 720000,
};
